import * as Yup from "yup";

export const CategoryValidationSchema = Yup.object({
  name: Yup.string().required("Name is required"),
  description: Yup.string().notRequired(),
});
